import React, { useState, useEffect } from 'react';
import { Room, RoomEvent, RemoteParticipant, DataPacket_Kind } from 'livekit-client';

interface ChatOverlayProps { room: Room; }
export const ChatOverlay: React.FC<ChatOverlayProps> = ({ room }) => {
  const [messages, setMessages] = useState<{ from: string; text: string }[]>([]);

  useEffect(() => {
    const handler = (payload: Uint8Array, participant?: RemoteParticipant) => {
      try {
        const msg = JSON.parse(new TextDecoder().decode(payload));
        if (msg.type === 'chat' && participant) {
          setMessages(m => [...m, { from: participant.identity, text: msg.text }]);
        }
      } catch { /* ignore */ }
    };
    room.on(RoomEvent.DataReceived, handler);
    return () => room.off(RoomEvent.DataReceived, handler);
  }, [room]);

  const send = (text: string) => {
    room.localParticipant.publishData(
      new TextEncoder().encode(JSON.stringify({ type: 'chat', text })),
      DataPacket_Kind.RELIABLE
    );
  };

  return (
    <div className="absolute right-2 bottom-16 w-48 max-h-64 overflow-auto bg-black bg-opacity-50 text-white text-sm p-2 z-30">
      {messages.map((m, i) => (
        <div key={i}><b>{m.from}:</b> {m.text}</div>
      ))}
      <input
        type="text"
        onKeyDown={e => {
          if (e.key === 'Enter' && e.currentTarget.value) {
            send(e.currentTarget.value);
            e.currentTarget.value = '';
          }
        }}
        placeholder="Type a message..."
        className="w-full mt-1 p-1 text-black"
      />
    </div>
  );
};
